import { ModalController } from '@ionic/angular';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'shc-report-modal',
  templateUrl: './report-modal.component.html',
  styleUrls: ['./report-modal.component.scss'],
})
export class ReportModalComponent implements OnInit {
  message: string;

  constructor(
    private modalCtrl: ModalController,
  ) { }

  ngOnInit() { }

  dismiss() {
    this.modalCtrl.dismiss(this.message);
  }
}
